import FarmFeedSearch from './FarmFeedSearch';

export default FarmFeedSearch;
